export type ResultStatusTableCellProps = {
  status: string;
};

export type CircleProps = {
  color: string;
};

export { default as ResultStatusTableCell } from './ResultStatusTableCell';
